import { PaletteMode } from "@mui/material";
import { puzsqThemeOptions } from "./themeOptions";
export const siteConfig = (themeMode: PaletteMode) => ({
  serviceId: "puzsq",
  siteName: "Puzsq CreatorHub",
  hashedPassword: "",
  themeOptions: puzsqThemeOptions(themeMode),
});
